import { TERMS } from '../../settings';
import { useEffect } from 'react';

const Terms = (): void => {
  useEffect(() => {
    window.location.href = TERMS
  }, []);

  return null;
}

export default Terms;
